import { useState } from 'react';
import { toast } from 'sonner';

export const useCopy = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (data: string) => {
    if (data) {
      navigator.clipboard.writeText(data);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      toast.success('Successfully copied to clipboard');
    }
  };

  return {
    copied,
    handleCopy,
  };
};
